import api from '@/api'
import Cookies from 'js-cookie'

export default {
  state: () => ({
    token: Cookies.get('token') || '',
    isLogin: !!Cookies.get('token'),
    userInfo: {
      profile: {}
    }
  }),
  getters: {
    token(state) {
      return state.token
    },
    isLogin(state) {
      return state.isLogin
    },
    userInfo(state) {
      return state.userInfo
    }
  },
  mutations: {
    setName(state, name) {
      state.name = name
    },
    setLoginStatus(state, isLogin) {
      state.isLogin = isLogin
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setCookie(state, token) {
      if (token) {
        Cookies.set('token', token)
      } else {
        Cookies.remove('token')
      }
      state.token = token
    }
  },
  actions: {
    setLoginStatus({ commit }, isLogin) {
      commit('setLoginStatus', isLogin)
    },
    async getUserInfo({ commit, state }) {
      if (state.token) {
        const { data, success } = await api.user.userInfo() || {}
        if (success) {
          commit('setUserInfo', data)
          commit('setLoginStatus', true)
        }
      }
    },
    setCookie({ commit }, token) {
      commit('setCookie', token)
    },
    clearUser({ commit }) {
      commit('setLoginStatus', false)
      commit('setUserInfo', {})
      commit('setFirstCategory', [])
      commit('setCategory', [])
      commit('setCookie', '')
    }
  }
}
